import { useSyncExternalStore } from "react";

// The hint on controls that only the server can carry out.
export const NEEDS_NETWORK = "Нужен интернет";

function subscribe(onChange: () => void): () => void {
  window.addEventListener("online", onChange);
  window.addEventListener("offline", onChange);
  return () => {
    window.removeEventListener("online", onChange);
    window.removeEventListener("offline", onChange);
  };
}

const isOnline = () => navigator.onLine;
const onServer = () => true;

export function useOnline(): boolean {
  return useSyncExternalStore(subscribe, isOnline, onServer);
}
